<template>
  <v-card class="px-3" :loading="loading">
    <v-card-text>
      <Germany v-if="view == 'germany'" :lead="lead" :arabic="arabic" />
      <Program v-if="view == 'program'" :lead="lead" :arabic="arabic"/>
      <Aramcco v-if="view == 'aramcco'" :lead="lead" :arabic="arabic" />
      <Costs v-if="view == 'costs'" :lead="lead" :arabic="arabic" />
    </v-card-text>
  </v-card>
</template>

<script>
import Germany from './Germany'
import Program from './Program'
import Aramcco from './Aramcco'
import Costs from './Costs'
export default {
  components: { Germany, Program, Aramcco, Costs },
  props:['loading', 'arabic', 'view', 'lead', 'confirmed'],
  data(){
    return {
    }
  },
  methods:{
    
  },
  computed:{
    
  }
}
</script>

<style>

</style>